<h1>Affiliates</h1>
<p>Order is from left to right. Drag affiliates to reorder them.</p>
<div class="row-cols-1 row-cols-md-2 g-4 mt-1">
  <app-drag-drop-multi-direction
    [items]="affiliates"
    (arrayChanged)="updateAffiliatestOrder($event)"
    (editIconClick)="edit($event)"
    (deleteIconClick)="confirmDelete($event)"
    [configuration]="configuration"> 
  </app-drag-drop-multi-direction>
</div>

  <div class="center mt-5 pb-5">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="addAffiliate()"
      [attr.aria-expanded]="isCollapsed"
      aria-controls="collapseExample"
      aria-label="add"
    >
      <fa-icon [icon]="faPlusSquare"></fa-icon>
    </button>
  </div>
  <div #collapse="ngbCollapse" [ngbCollapse]="!isCollapsed" (ngbCollapseChange)="isCollapsed = $event">
    <app-affiliates-form
      [affiliateData]="affiliateData"
      (refreshData)="getAffiliates()"
    ></app-affiliates-form>
  </div>

